import { A4uLocation as IconComponent } from '@adobe/react-spectrum-workflow/dist/Location.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Location(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}